import { defineMessages } from "react-intl";

import {
	papanicolaouTestMessages,
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/tumour-research/gynecology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	gynecology: {
		id: "ktx.gynecology.title",
		defaultMessage: "Nőgyógyászat"
	},
	result: {
		id: "ktx.gynecology.field.result",
		defaultMessage: "Eredmény"
	},
	papanicolaouTest: {
		id: "ktx.gynecology.field.papanicolaouTest",
		defaultMessage: "Méhnyakrák szűrés"
	},
	comment: {
		id: "ktx.gynecology.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	papanicolaouTest: {
		type: "field",
		path: ["papanicolaou_test"],
		label: messages.papanicolaouTest,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: papanicolaouTestMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.papanicolaouTest }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_gynecology",
	value: {
		schemaId: "gynecology",
		title: messages.gynecology,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
